import { Dialog } from '@headlessui/react'
import { useDispatch, useSelector } from 'react-redux'

import { AnimatePresence, motion, useAnimation } from 'framer-motion'
import { useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { recognitionSection } from '../../common/constants'
import { RECOGNISED_SECTION_MODAL_DETAILS, SET_SHOW_RECOGNISED_SECTION } from '../../redux/actions/types'



const OurLeanersModal = ({ showRecognisedSection }) => {

    const recognisedSectionDetails = useSelector((store) => store?.userActivity?.recognisedSectionModalDetails)
    const recognisedSectionIndex = useSelector((store) => store?.userActivity?.recognisedSectionModalIndex)

    const statements = recognisedSectionDetails?.statements

    console.log('change' , recognisedSectionDetails)
    const dispatch = useDispatch()

    const [ role, setRole ] = useState('')
    const [ phase, setPhase ] = useState(0)
    const [ cardWidth, setCardWidth ] = useState(0)
    const [ organisation, setOrganisation ] = useState('')
    const [ animateText, setAnimateText ] = useState(false)
    const [ showCloseButton, setShowCloseButton ] = useState(false)
    const [ showShineAnimation, setShowShineAnimation ] = useState(false)
    
    const cardRef = useRef(null)

    const controls = useAnimation()

    const  width  = window.innerWidth;

    useEffect(() => {
        if (cardRef.current) {
            setCardWidth(cardRef.current.offsetWidth)
        }
    }, [])

    useEffect(() => {
        setPhase(0)
    }, [recognisedSectionIndex])

    useEffect(() => {
        if (phase < statements.length * 4) {
            const mod = phase % 4
            const delay =
                mod === 0 ? 1200 : // time for pulsing effect
                mod === 1 ? 200 :  // time for tick mark
                mod === 2 ? 150 :  // time to grow line
                200                // time to preview next
            const timer = setTimeout(() => setPhase(p => p + 1), delay)
            return () => clearTimeout(timer)
        }
    }, [phase, statements.length])
    
    useEffect(() => {
        const shouldAnimate = recognisedSectionDetails?.previousOrg && recognisedSectionDetails?.previousRole && recognisedSectionDetails?.finalRole && recognisedSectionDetails?.finalOrg
        if (shouldAnimate) {
            setOrganisation(recognisedSectionDetails?.previousOrg)
            setRole(recognisedSectionDetails?.previousRole)
            const startTimer = setTimeout(() => {
                setAnimateText(true)
            }, 5000)
            const changeTextTimer = setTimeout(() => {
                setOrganisation(recognisedSectionDetails?.finalOrg)
                setRole(recognisedSectionDetails?.finalRole)
            }, 5300)
      
            const stopTimer = setTimeout(() => {
                setAnimateText(false)
            }, 6200)
            const shineCardTimer = setTimeout(() => {
                setShowShineAnimation(true)
            }, 7200)

            const stopShineCardTimer = setTimeout(() => {
                setShowShineAnimation(false)
            }, 8200)
            return () => {
                clearTimeout(startTimer)
                clearTimeout(stopTimer)
                clearTimeout(changeTextTimer)
                clearTimeout(shineCardTimer)
                clearTimeout(stopShineCardTimer)
            }
        }else{
            setOrganisation(recognisedSectionDetails?.finalOrg)
            setRole(recognisedSectionDetails?.finalRole)
        }
    }, [recognisedSectionDetails, recognisedSectionIndex])

    useEffect(() => {
        let changeContentTimer 
        const shouldAnimate = recognisedSectionDetails?.previousOrg && recognisedSectionDetails?.previousRole && recognisedSectionDetails?.finalRole && recognisedSectionDetails?.finalOrg
        if(shouldAnimate){
            changeContentTimer = setTimeout(() => {
                const nextIndex = (recognisedSectionIndex + 1)%recognitionSection?.length
                dispatch({ type: RECOGNISED_SECTION_MODAL_DETAILS, payload: { item :recognitionSection[nextIndex], originalIndex: nextIndex }})
            }, 12200)
        }else{
            changeContentTimer = setTimeout(() => {
                const nextIndex = (recognisedSectionIndex + 1)%recognitionSection?.length
                dispatch({ type: RECOGNISED_SECTION_MODAL_DETAILS, payload: { item :recognitionSection[nextIndex], originalIndex: nextIndex }})
            }, 9000)
        }
        return () => {
            clearTimeout(changeContentTimer)
        }
    }, [dispatch, recognisedSectionDetails?.finalOrg, recognisedSectionDetails?.finalRole, recognisedSectionDetails?.previousOrg, recognisedSectionDetails?.previousRole, recognisedSectionIndex])

    useEffect(() => {
        const animateCard = async () => {
            if (!animateText || !cardWidth) return
            await controls.start({
                x: -cardWidth,
                opacity: 0,
                transition: { duration: 0.6, ease: 'easeInOut' },
            })
            await controls.set({ x: cardWidth })
            await controls.start({
                x: 0,
                opacity: 1,
                transition: { duration: 0.6, ease: 'easeInOut' },
            })
        }

        animateCard()
    }, [animateText, cardWidth, controls])

    useEffect(() => {
        const totalPhases = statements.length * 4 // each statement takes ~4 steps
        const delay = totalPhases * 300 // each step is approx 300ms

        const timeout = setTimeout(() => {
            setShowCloseButton(true)
        }, delay)

        return () => {
            clearTimeout(timeout)
            setShowCloseButton(false) // hide it on cleanup/data change
        }
    }, [recognisedSectionDetails, statements])

    const handleClose = () => {
        // if (swiperInstance?.autoplay) {
        //     swiperInstance.autoplay.start()
        // }
        dispatch({ type: SET_SHOW_RECOGNISED_SECTION, payload: false })
    }

    return (
        <div className='w-full'>
            <Dialog
                open={showRecognisedSection}
                onClose={handleClose}
                as='div'
                className="fixed inset-0 z-[100] text-white"
            >
                {/* Animated overlay */}
                <AnimatePresence>
                    {showRecognisedSection && (
                        <motion.div
                            key={`overlay-${recognisedSectionIndex}`}
                            className="fixed inset-0 bg-black/80"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.2, ease: 'easeOut' }}
                        />
                    )}
                </AnimatePresence>
                <Dialog.Title/>
                <Dialog.Description/>
                <div className='fixed inset-0 flex items-center justify-center p-4'>
                    {/* Animated modal container */}
                    <AnimatePresence mode="wait">
                        {showRecognisedSection && (
                            <motion.div
                                key={`panel-${recognisedSectionIndex}`}
                                initial={{ opacity: 0, y: 16, scale: 0.98 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 16, scale: 0.98 }}
                                transition={{ duration: 0.35, ease: 'easeOut' }}
                                className='h-[400px] w-[95%] max-w-md overflow-visible'
                                ref={cardRef}
                            >
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={recognisedSectionIndex}
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.4, ease: "easeOut" }}
                            exit={{ scale: 0.8, opacity: 0 }}
                            className='p-[0.5px] rounded-lg w-full'
                            style={{
                                backgroundImage: 'linear-gradient(to bottom, rgba(112, 174, 255, 0.6) 35%, rgba(253, 253, 253, 0) 82%'
                            }}
                        >
                            <div className={`${showShineAnimation && 'btn--glow'} w-full bg-[#283E54] rounded-lg px-4 pt-4 pb-6`}>
                                <div className='relative'>
                                    <img src="https://assets.learntube.ai/files/recognised_section/white-shade.png?updatedAt=1745830024187" width={176} height={176} className='mx-auto w-auto h-[100px] object-cover object-center -mt-4' alt="" />
                                    <div className='absolute left-1/2 top-4 -translate-x-1/2'>
                                        <img 
                                            src={recognisedSectionDetails?.companyImage} 
                                            height={40} 
                                            width={60} 
                                            className={`m-auto ${recognisedSectionDetails?.showText ? 'h-10' : 'h-[56px]'} w-auto`}
                                            alt=""
                                            style={{
                                                filter: 'drop-shadow(0px 0.5px 0px #424447) drop-shadow(0px 1px 0px #424447) drop-shadow(0px 1.5px 0px #424447) drop-shadow(0px 2px 0px #424447)',
                                            }}
                                        />
                                        {recognisedSectionDetails?.showText && <p className='text-xs font-semibold mt-2 text-center'>{recognisedSectionDetails?.finalOrgTitle}</p>}
                                    </div>
                                </div>
                                <div>
                                    <motion.div 
                                        className='flex gap-4 items-center mb-6'
                                        animate={controls}
                                        initial={{ x: 0 }}
                                    >
                                        <div>
                                            <img src={recognisedSectionDetails?.profileImage} width={64} height={64} className='w-16 h-16 rounded-lg border border-white' alt="" />
                                        </div>
                                        <div className='flex-1'>
                                            <h4 className='font-semibold'>{recognisedSectionDetails?.name}</h4>
                                            <div className='mt-2 text-xs'>
                                                <p className={`line-clamp-1`}>{role}</p>
                                                <p className={`text-white/50 mt-0.5 line-clamp-1`}>{organisation}<span className='px-2'>&bull;</span><img src="https://assets.learntube.ai/files/recognised_section/Map%20pin.png?updatedAt=1745839287883" width={12} height={12} className='image-inline' alt="" /> {recognisedSectionDetails?.city}</p>
                                            </div>
                                        </div>
                                    </motion.div>
                                </div>
                                <div className='w-full border-b border-white/20' />
                                <div className='mt-6'>
                                <div className="flex flex-col relative">
                                    {statements.map((item, index) => {
                                        const dotPhase = phase - index * 4
                                        const isLast = index === statements.length - 1
                                        
                                        const showDot = dotPhase >= 0
                                        const isPulsing = dotPhase === 0 || (index === statements.length - 1 && dotPhase >= 0)
                                        const isTicking = dotPhase >= 1 && !isLast
                                        const showLine = dotPhase >= 2 && index < statements.length - 1
                                        const showNextText = dotPhase === 3 && index < statements.length - 1
                                        return (
                                            <div key={index} className="relative flex flex-col">
                                                {showDot && (<div className="flex items-center gap-2">
                                                    <motion.div
                                                        initial={{ scale: 0 }}
                                                        animate={{ scale: 1 }}
                                                        className={`w-2 h-2 rounded-full flex items-center justify-center relative ${isTicking ? "bg-[#536576] text-white" : "bg-[#70AEFF]"}`}
                                                    >
                                                        {isPulsing && (
                                                            <span className="absolute w-full h-full rounded-full bg-[#70AEFF] animate-ping opacity-75" />
                                                        )}
                                                        {isTicking && (
                                                            <FontAwesomeIcon icon={faCheck} className="text-[6px] z-10" />
                                                        )}
                                                    </motion.div>
                                                    <span className={`${width < 412 ? 'text-xxs' : 'text-xs'} ${index === statements.length - 1 ? "text-white" : "text-white/60"} line-clamp-1`}>
                                                        {item}
                                                    </span>
                                                </div>)}
                                                {showLine && (<div className="relative h-3">
                                                    <motion.div
                                                        initial={{ height: 0 }}
                                                        animate={{ height: 19 }}
                                                        transition={{ duration: 0.15, ease: "easeIn" }}
                                                        className="absolute left-[3px] -top-[3px] w-0.5 bg-white/20"
                                                    />
                                                </div>)}
                                                {showNextText && (<div className="flex items-center gap-2">
                                                    <motion.div
                                                        initial={{ scale: 0 }}
                                                        animate={{ scale: 1 }}
                                                        className="w-2 h-2 rounded-full bg-[#70AEFF] relative"
                                                    >
                                                        <span className="absolute w-full h-full rounded-full bg-[#70AEFF] animate-ping opacity-75"></span>
                                                    </motion.div>
                                                    <span className={`${index === statements.length - 1 ? "text-white" : "text-white/60"} ${width < 412 ? 'text-xxs' : 'text-xs'}`}>{statements[index + 1]}</span>
                                                </div>)}
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                    <AnimatePresence mode="wait">
                        {showCloseButton && <motion.div 
                            className='cursor-pointer mx-auto mt-4 backdrop-blur-sm w-10 h-10 rounded-full flex items-center justify-center bg-white/20'
                            key={`close-${recognisedSectionIndex}`}
                            onClick={handleClose}
                            initial={{
                                opacity: 0,
                                scale: 0.8
                            }}
                            transition={{
                                duration: 0.15
                            }}
                            animate={{
                                opacity: 1,
                                scale: 1
                            }}
                            exit={{ 
                                opacity: 0, 
                                scale: 0.8 
                            }}
                        >
                            <img src="https://assets.learntube.ai/files/recognised_section/X.png?updatedAt=1746165712541" width={20} height={20} alt="" />
                        </motion.div>}
                    </AnimatePresence>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            </Dialog>
        </div>
    )
}

export default OurLeanersModal